import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import StepsContainer from "../StepsContainer";
import FirstStep from "../StepsContainer/FirstStep";
import { BirthDayConfig } from "../../../models/BirthDaysModels/BirthDayConfig";
import { BirthdayAssortWithSteps } from "../../../models/BirthDaysModels/BirthdayAssortWithSteps";
import "./style.scss";
import getId from "../../../../utils/getId";
import { END_STEP_TITLE, SECOND_STEP_TITLE, THIRD_STEP_TITLE } from "../message";
import SecondStep from "../StepsContainer/SecondStep";
import { BirthDayTimeAndQnt } from "../../../models/BirthDaysModels/BirthDayTimeAndQnt";
import ThirdStep from "../StepsContainer/ThirdStep";
import { BirthDayDetails } from "../../../models/BirthDaysModels/BirthDayDetails";
import AnotherSteps from "../StepsContainer/AnotherSteps";
import { BirthDayStep } from "../../../models/BirthDaysModels/BirthDayStep";
import { BasketItem } from "../../../models/BasketItem";
import EndStep from "../StepsContainer/EndStep";
import { Assort } from "../../../models/Assort";
import { useTranslation } from "react-i18next";

interface IProps {
  birthDayData: BirthDayConfig;
  selectedAssort: BirthdayAssortWithSteps;
  onSelectAssort: (value: BirthdayAssortWithSteps) => void;
  birthDayTimeAndQnt: BirthDayTimeAndQnt;
  onSetBirthDatTimeAndQnt: (value: BirthDayTimeAndQnt) => void;
  birthDayDetails: BirthDayDetails;
  onSetBirthDayDetails: (value: BirthDayDetails) => void;
  lines: BasketItem[];
  onAddLine: (assort: Assort, qnt: number) => void;
  clearReservation: () => void;
  saveReservation: () => void;
  activeStepThree: boolean;
  setActiveStepThree: (value: boolean) => void;
  activeStepsAnother: boolean;
  setActiveStepsAnother: (value: boolean) => void;
  onSelectLineAndDeleteOthers: (assort: Assort, assortsToDelete: Assort[]) => void;
}

const BirthdayRightContainer: React.FC<IProps> = ({
  birthDayData,
  selectedAssort,
  onSelectAssort,
  birthDayTimeAndQnt,
  onSetBirthDatTimeAndQnt,
  birthDayDetails,
  onSetBirthDayDetails,
  lines,
  onAddLine,
  clearReservation,
  saveReservation,
  activeStepThree,
  setActiveStepThree,
  activeStepsAnother,
  setActiveStepsAnother,
  onSelectLineAndDeleteOthers,
}: IProps) => {
  const { t } = useTranslation();
  const [step, setStep] = useState<number>(1);

  const handleStep = (step: number) => {
    setStep(step);
    setActiveStepThree(false);
    setActiveStepsAnother(false);
  };

  const handleSelectLineAndDeleteOthers = (assorts: Assort[], assort: Assort) => {
    const assortsToDelete = assorts.filter((item) => getId(item) !== getId(assort));
    onSelectLineAndDeleteOthers(assort, assortsToDelete);
  };

  return (
    <Box className={"birthday-right-container"}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {birthDayData.mainAssorts && (
            <StepsContainer stepsNumber={`${t("krok")}. 1`} title={birthDayData.mainAssorts.title}>
              <FirstStep
                assorts={birthDayData.mainAssorts.assorts}
                selectedAssort={selectedAssort}
                onSelectAssort={onSelectAssort}
                handleStep={handleStep}
              />
            </StepsContainer>
          )}

          {Boolean(getId(selectedAssort)) && step > 1 && (
            <StepsContainer stepsNumber={`${t("krok")}. 2`} title={t(SECOND_STEP_TITLE)}>
              <SecondStep
                reservationName={selectedAssort.name}
                birthDayTimeAndQnt={birthDayTimeAndQnt}
                onSetBirthDatTimeAndQnt={onSetBirthDatTimeAndQnt}
                assortIds={getId(selectedAssort)}
                onNext={() => setActiveStepThree(true)}
              />
            </StepsContainer>
          )}
          {activeStepThree && (
            <StepsContainer stepsNumber={`${t("krok")}. 3`} title={t(THIRD_STEP_TITLE)}>
              <ThirdStep
                birthDayDetails={birthDayDetails}
                onSetBirthDayDetails={onSetBirthDayDetails}
                onNext={() => setActiveStepsAnother(true)}
              />
            </StepsContainer>
          )}
          {activeStepsAnother && (
            <React.Fragment>
              {selectedAssort.steps.map((item: BirthDayStep, index: number) => (
                <StepsContainer stepsNumber={`${t("krok")}. ${index + 4}`} title={item.title}>
                  <AnotherSteps
                    key={item.title}
                    assorts={item.assorts}
                    onAddLine={onAddLine}
                    limitToOneItem={index === 0}
                    lines={lines}
                    onSelectLine={(assort) => handleSelectLineAndDeleteOthers(item.assorts, assort)}
                  />
                </StepsContainer>
              ))}
              <StepsContainer
                stepsNumber={`${t("krok")}. ${selectedAssort.steps.length + 4}`}
                title={t(END_STEP_TITLE)}
              >
                <EndStep
                  reservationName={selectedAssort.name}
                  reservationDate={birthDayTimeAndQnt.date}
                  qnt={birthDayTimeAndQnt.qnt}
                  lines={lines}
                  clearReservation={clearReservation}
                  saveReservation={saveReservation}
                />
              </StepsContainer>
            </React.Fragment>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default BirthdayRightContainer;
